import {
  BrowserCacheLocation,
  EventType
} from "@azure/msal-browser";
import { PublicClientApplicationSingleton } from "./PublicClientApplicationSingleton.js";
import { useRuntimeConfig } from "nuxt/app";
let tokenExpirationTimer;
export const useMSAuth = () => {
  const atomNuxtConfig = useRuntimeConfig().public.atomNuxt;
  const msalConfig = {
    auth: {
      clientId: atomNuxtConfig.azureAdB2C?.clientId,
      authority: atomNuxtConfig.azureAdB2C?.authority,
      redirectUri: atomNuxtConfig.azureAdB2C?.redirectUri,
      postLogoutRedirectUri: atomNuxtConfig.azureAdB2C?.postLogoutRedirectUri,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true
    },
    system: {
      tokenRenewalOffsetSeconds: 300
    }
  };
  const msalInstance = PublicClientApplicationSingleton.create(msalConfig);
  async function initialize() {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise().then(handleResponse).catch((err) => {
      throw new Error(err);
    });
    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        setupTokenExpirationTimer();
      }
    });
  }
  function handleResponse(resp) {
    if (resp && resp.account) {
      setupTokenExpirationTimer();
    } else {
    }
  }
  function setupTokenExpirationTimer() {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      const account = accounts[0];
      if (account.idTokenClaims && account.idTokenClaims.exp) {
        const tokenExpirationTime = account.idTokenClaims.exp * 1e3;
        const currentTime = Date.now();
        const timeUntilExpiration = tokenExpirationTime - currentTime;
        clearTimeout(tokenExpirationTimer);
        tokenExpirationTimer = setTimeout(() => {
          refreshAccessToken(account);
        }, timeUntilExpiration);
      }
    }
  }
  async function refreshAccessToken(account) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        account,
        scopes: atomNuxtConfig.azureAdB2C.scopes
      });
      setupTokenExpirationTimer();
    } catch (err) {
      console.error("Token refresh error:", err);
    }
  }
  const loginRequest = {
    scopes: atomNuxtConfig.azureAdB2C?.scopes
  };
  async function signIn() {
    try {
      await msalInstance.loginRedirect(loginRequest);
    } catch (err) {
    }
  }
  async function acquireTokensSilent() {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      const account = accounts[0];
      msalInstance.setActiveAccount(account);
      try {
        const response = await msalInstance.acquireTokenSilent({
          account,
          scopes: atomNuxtConfig.azureAdB2C?.scopes
        });
        return { accessToken: response.accessToken, idToken: response.idToken };
      } catch (err) {
        return null;
      }
    } else {
      console.error("No accounts found");
      return null;
    }
  }
  function getAccounts() {
    return msalInstance.getAllAccounts();
  }
  function isAuthenticated() {
    return getAccounts().length > 0;
  }
  async function signOut() {
    const accounts = msalInstance.getAllAccounts();
    const account = accounts[0];
    if (account) {
      await msalInstance.logoutRedirect({
        account
      });
      localStorage.clear();
    } else {
      console.error("Account not found");
    }
  }
  return {
    initialize,
    msalInstance,
    signIn,
    getAccounts,
    acquireTokensSilent,
    isAuthenticated,
    signOut
  };
};
